module.exports = __webpack_public_path__ + "static/media/skater6.443c0b7b.jpg";